import publicRoutes from "./public/index";
import adminRoutes from "./admin/index";

export default [...publicRoutes, ...adminRoutes];
